import { CommercialFeatureFlags } from '../ee/commercialFeatureFlags';
import { FeatureFlags } from '../types/featureFlags';
/**
 * Flags that must NOT be force-enabled in preview environments. Everything
 * else is on by default there so QA can exercise recent features without a
 * redeploy. Keep the reason next to each entry.
 */
const PREVIEW_EXCLUDED_FEATURE_FLAGS = new Set([
    // Blocks or degrades every page.
    FeatureFlags.OrganizationTrialBlock,
    FeatureFlags.OrganizationTrialWarning,
    // Changes query or compile semantics, so QA results would be misleading.
    FeatureFlags.CalculateSeriesColor,
    // Changes the signup flow and needs SMTP for the email OTP. The register
    // page evaluates it anonymously, so an override can't switch it back off.
    FeatureFlags.NewOnboarding,
    // Off pending a security review.
    FeatureFlags.SsoOrganizationSettings,
    // Security hardening: previews must not accept long-lived GitHub PATs.
    FeatureFlags.AiMcpGithubPat,
    // Same reason: the dashboard E2E specs drive the navigate-away "New chart"
    // flow, which the in-dashboard modal replaces. Opt-in POC — keep previews
    // on the shipped path until it has its own coverage. The metrics layer
    // rides inside the modal, so it must stay off with it.
    FeatureFlags.InDashboardChartEditor,
    FeatureFlags.DashboardCustomMetrics,
    // Replaces the dashboard filter bar's edit mode with a sidebar that is
    // still being built. Opt-in: previews and the dashboard E2E specs stay on
    // the shipped filter popover.
    FeatureFlags.DashboardControls,
    // Derived from instance configuration: left to their config handler so a
    // preview never advertises a feature whose backend isn't configured.
    CommercialFeatureFlags.AiCopilot,
    // Changes permission semantics per org: makes the org custom role's PAT
    // scope authoritative. Opt-in only; QA enables via feature_flag_overrides.
    CommercialFeatureFlags.PatScopeAuthoritative,
    FeatureFlags.ResultsCacheEnabled,
    FeatureFlags.EnableTimezoneSupport,
]);
export const ALL_FEATURE_FLAG_IDS = [
    ...Object.values(FeatureFlags),
    ...Object.values(CommercialFeatureFlags),
].sort();
const KNOWN_FEATURE_FLAG_IDS = new Set(ALL_FEATURE_FLAG_IDS);
export const isKnownFeatureFlagId = (flagId) => KNOWN_FEATURE_FLAG_IDS.has(flagId);
/** Flags enabled by default in preview environments. */
export const PREVIEW_ENABLED_FEATURE_FLAGS = new Set(ALL_FEATURE_FLAG_IDS.filter((flagId) => !PREVIEW_EXCLUDED_FEATURE_FLAGS.has(flagId)));
//# sourceMappingURL=previewFeatureFlags.js.map